module.exports = __webpack_public_path__ + "img/pdf.fa35f76d.png";